import { render, staticRenderFns } from "./DirectTag.vue?vue&type=template&id=10479bcd&scoped=true&lang=pug"
import script from "./DirectTag.vue?vue&type=script&lang=js"
export * from "./DirectTag.vue?vue&type=script&lang=js"
import style0 from "./DirectTag.vue?vue&type=style&index=0&id=10479bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10479bcd",
  null
  
)

export default component.exports